/* ============================================================
   HERWEAR — Theme behavior core (global.js)
   Ported mockup interactions + Shopify AJAX cart.
   Vanilla JS, no dependencies. Robust to missing elements.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };

  /* RTL helpers (Shopify sets dir via {{ request.locale.iso_code }} / theme) */
  function isRTL() {
    return (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
  }

  /* Locale-aware routes prefix (e.g. /en, /ar). window.routes is set in theme.liquid. */
  var ROOT = (window.routes && window.routes.root_url) ? window.routes.root_url.replace(/\/$/, '') : '';
  function sectionsUrl(section) {
    return (ROOT || '') + '/?sections=' + section;
  }

  /* ---- sticky header shadow ---- */
  var header = $('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- generic panel open/close (drawers, overlays, search) ---- */
  var overlay = $('#overlay');
  var openPanels = [];

  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (openPanels.indexOf(el) === -1) openPanels.push(el);
    var focusable = el.querySelector('input,button,a');
    if (focusable && el.classList.contains('search-panel')) setTimeout(function () { focusable.focus(); }, 280);
  }
  function closeAll() {
    openPanels.forEach(function (p) { p.classList.remove('is-open'); });
    openPanels = [];
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  on(overlay, 'click', closeAll);
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* Delegated so dynamically re-rendered markup (cart drawer) keeps working */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openPanel($(opener.getAttribute('data-open'))); return; }
    var closer = e.target.closest && e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closeAll(); return; }
  });

  /* ---- cart count display ---- */
  function setCartCount(n) {
    n = Math.max(0, parseInt(n, 10) || 0);
    $$('.cart-count').forEach(function (el) {
      el.textContent = n;
      el.style.display = n ? 'grid' : 'none';
      if (el.animate) {
        el.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }],
          { duration: 320, easing: 'ease' }
        );
      }
    });
  }

  /* ---- toast ---- */
  function toast(msg) {
    var t = $('#toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'toast';
      t.className = 'toast';
      document.body.appendChild(t);
    }
    t.innerHTML = '<span class="toast__check">✓</span><span></span>';
    t.lastChild.textContent = msg;
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    clearTimeout(t._tm);
    t._tm = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }
  function t9n(key, fallback) {
    return (window.themeStrings && window.themeStrings[key]) || fallback;
  }

  /* ---- quantity steppers (PDP + cart) ---- */
  function bindQty(scope) {
    $$('.qty', scope || document).forEach(function (q) {
      if (q._bound) return; q._bound = true;
      var input = $('input', q);
      var dec = $('[data-step="-1"]', q);
      var inc = $('[data-step="1"]', q);
      var clamp = function (v) { return Math.max(1, Math.min(99, v || 1)); };
      on(dec, 'click', function () {
        input.value = clamp(parseInt(input.value, 10) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      on(inc, 'click', function () {
        input.value = clamp(parseInt(input.value, 10) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
  bindQty();

  /* ============================================================
     VARIANT PICKER (Dawn-style lookup keyed on the options array)
     Reads option buttons [data-opt-value][data-option-position] grouped by
     [data-option-position], resolves the selected combination against the
     <script data-variants> blob, then updates the hidden #id input, the
     add-to-cart button (price / availability) and the buy-bar.
     ============================================================ */
  function initVariantPickers() {
    $$('.pdp, [data-section-type="main-product"]').forEach(function (root) {
      var variantsEl = root.querySelector('[data-variants]');
      var idInput = root.querySelector('input[name="id"][data-variant-id]') ||
                    root.querySelector('input[name="id"]');
      if (!variantsEl || !idInput) return;
      if (root._variantBound) return; root._variantBound = true;

      var variants;
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
      if (!Array.isArray(variants)) return;

      var groups = $$('[data-option-position]', root).filter(function (g) {
        // a group container holds option buttons; buttons themselves also carry
        // data-option-position, so keep only elements that contain buttons.
        return g.querySelector('[data-opt-value]');
      });

      function selectedOptions() {
        var opts = [];
        groups.forEach(function (group) {
          var pos = parseInt(group.getAttribute('data-option-position'), 10) || 1;
          var chosen = group.querySelector('[data-opt-value].is-on') ||
                       group.querySelector('[data-opt-value]');
          opts[pos - 1] = chosen ? chosen.getAttribute('data-opt-value') : null;
        });
        return opts;
      }

      function findVariant(opts) {
        return variants.filter(function (variant) {
          return variant.options.every(function (val, i) {
            return opts[i] == null || val === opts[i];
          });
        })[0];
      }

      // all add-to-cart buttons that target this product (in-form + external buy-bar)
      function getAddButtons() {
        var section = root.closest('section') || document;
        var btns = $$('[data-add-to-cart]', section);
        $$('[data-add-to-cart][form]').forEach(function (b) {
          if (btns.indexOf(b) === -1) btns.push(b);
        });
        return btns;
      }

      function update() {
        var opts = selectedOptions();
        var variant = findVariant(opts);
        var addBtns = getAddButtons();

        // reflect the chosen value in each option head (.val)
        groups.forEach(function (group) {
          var head = group.parentElement && group.parentElement.querySelector('.val');
          var chosen = group.querySelector('[data-opt-value].is-on');
          if (head && chosen) head.textContent = chosen.getAttribute('data-opt-value');
        });

        if (!variant) {
          addBtns.forEach(function (b) {
            b.setAttribute('disabled', 'disabled');
            var txt = b.querySelector('[data-add-text]') || b;
            var so = b.getAttribute('data-sold-out-text');
            if (so) txt.textContent = so;
          });
          return;
        }

        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));

        var priceStr = formatMoney(variant.price);

        addBtns.forEach(function (b) {
          var txt = b.querySelector('[data-add-text]') || b;
          if (variant.available) {
            b.removeAttribute('disabled');
            var tmpl = b.getAttribute('data-add-template');
            if (tmpl) txt.textContent = tmpl.replace('[price]', priceStr);
          } else {
            b.setAttribute('disabled', 'disabled');
            var so = b.getAttribute('data-sold-out-text');
            if (so) txt.textContent = so;
          }
        });

        // PDP price block + buy-bar price
        var priceBlock = root.querySelector('[data-price-block] .price');
        if (priceBlock) priceBlock.textContent = priceStr;
        var bbPrice = $('[data-buybar-price]');
        if (bbPrice) bbPrice.textContent = priceStr;

        // swap gallery image to the variant's featured media if present
        if (variant.featured_media && variant.featured_media.preview_image) {
          var gImg = root.querySelector('[data-gallery-image]');
          if (gImg && variant.featured_media.preview_image.src) {
            gImg.srcset = '';               // clear old srcset so the new src shows
            gImg.src = variant.featured_media.preview_image.src;
          }
          var mid = variant.featured_media.id;
          if (mid != null) {                // sync the active thumbnail
            var vth = document.querySelector('.gthumb[data-media-id="' + mid + '"]');
            if (vth) {
              $$('.gthumb').forEach(function (t) { t.classList.remove('is-on'); });
              vth.classList.add('is-on');
            }
          }
        }
      }

      groups.forEach(function (group) {
        $$('[data-opt-value]', group).forEach(function (opt) {
          on(opt, 'click', function () {
            if (opt.classList.contains('is-off') || opt.hasAttribute('disabled')) return;
            $$('[data-opt-value]', group).forEach(function (o) { o.classList.remove('is-on'); });
            opt.classList.add('is-on');
            update();
          });
        });
      });
    });
  }

  /* lightweight money formatter using window.HerwearSettings.moneyFormat */
  function formatMoney(cents) {
    var fmt = (window.HerwearSettings && window.HerwearSettings.moneyFormat) || '{{amount}}';
    var value = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var valueNoDec = Math.round(cents / 100).toLocaleString();
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, valueNoDec)
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, valueNoDec);
  }

  initVariantPickers();

  /* ============================================================
     WISHLIST — localStorage-backed, no app required.
     Stores product handles; [data-wish][data-product-handle] toggles
     and reflects saved state on every heart; header .wishlist-count badge;
     the wishlist page ([data-wishlist-page]) renders saved products by
     fetching /products/{handle}?view=card (alt template, layout none).
     ============================================================ */
  var WL_KEY = 'herwear:wishlist';
  function wlGet() {
    try { var v = JSON.parse(localStorage.getItem(WL_KEY)); return (v && v.length != null) ? v : []; }
    catch (e) { return []; }
  }
  function wlSave(list) { try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {} }
  function wlReflectCount() {
    var n = wlGet().length;
    $$('.wishlist-count, [data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n ? '' : 'none';
    });
  }
  function wlReflect() {
    var list = wlGet();
    $$('[data-wish][data-product-handle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-product-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    wlReflectCount();
  }
  function wlToggle(handle) {
    var list = wlGet();
    var i = list.indexOf(handle);
    var added;
    if (i === -1) { list.push(handle); added = true; } else { list.splice(i, 1); added = false; }
    wlSave(list);
    wlReflect();
    return added;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wish][data-product-handle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    var added = wlToggle(handle);
    toast(added ? t9n('wishlist_added', 'Saved to wishlist') : t9n('wishlist_removed', 'Removed from wishlist'));
    // on the wishlist page, drop the card when it is un-saved
    if (!added && $('[data-wishlist-page]')) {
      var card = btn.closest('[data-wishlist-item]');
      if (card) {
        card.style.transition = 'opacity .25s ease, transform .25s ease';
        card.style.opacity = '0';
        card.style.transform = 'translateY(8px)';
        setTimeout(function () { card.remove(); wlRenderEmptyState(); }, 250);
      }
    }
  });

  function wlRenderEmptyState() {
    var page = $('[data-wishlist-page]'); if (!page) return;
    var grid = $('#wishlist-grid', page);
    var empty = $('[data-wishlist-empty]', page);
    var has = grid && grid.children.length > 0;
    if (empty) empty.style.display = has ? 'none' : '';
    if (grid) grid.style.display = has ? '' : 'none';
  }
  function wlRenderPage() {
    var page = $('[data-wishlist-page]'); if (!page) return;
    var grid = $('#wishlist-grid', page);
    var loading = $('[data-wishlist-loading]', page);
    if (!grid) return;
    var list = wlGet();
    if (!list.length) { if (loading) loading.style.display = 'none'; wlRenderEmptyState(); return; }
    if (loading) loading.style.display = '';
    grid.innerHTML = '';
    var base = ROOT || '';
    Promise.all(list.map(function (handle) {
      return fetch(base + '/products/' + encodeURIComponent(handle) + '?view=card', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) { return { handle: handle, html: html }; })
        .catch(function () { return { handle: handle, html: null }; });
    })).then(function (results) {
      if (loading) loading.style.display = 'none';
      var missing = [];
      results.forEach(function (res) {
        if (!res.html || !res.html.trim()) { missing.push(res.handle); return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = res.html.trim();
        var cardEl = tmp.querySelector('.card') || tmp.firstElementChild;
        if (!cardEl) { missing.push(res.handle); return; }
        cardEl.setAttribute('data-wishlist-item', '');
        grid.appendChild(cardEl);
      });
      // prune handles whose product no longer exists / is unavailable
      if (missing.length) {
        wlSave(wlGet().filter(function (h) { return missing.indexOf(h) === -1; }));
      }
      wlReflect();
      wlRenderEmptyState();
      bindQty(grid);
    });
  }

  wlReflect();
  wlRenderPage();

  /* ---- Buy it now: add the current variant, then go straight to checkout ---- */
  document.addEventListener('click', function (e) {
    var bn = e.target.closest && e.target.closest('[data-buy-now]');
    if (!bn || bn.hasAttribute('disabled') || bn.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    var form = bn.closest('form') || $('form[action$="/cart/add"]') || $('.product-form');
    if (!form) return;
    bn.setAttribute('aria-disabled', 'true');
    fetch((ROOT || '') + '/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () { window.location.href = (ROOT || '') + '/checkout'; })
      .catch(function () { bn.removeAttribute('aria-disabled'); toast(t9n('cart_error', 'Could not proceed to checkout')); });
  });

  /* ---- Related products (Shopify recommendations, loaded on demand) ---- */
  (function () {
    var rel = $('[data-related-products][data-url]');
    if (!rel) return;
    fetch(rel.getAttribute('data-url'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-related-products]');
        if (fresh) { rel.innerHTML = fresh.innerHTML; wlReflect(); }
      })
      .catch(function () {});
  })();

  /* ---- Dual-handle price slider (collection filter) ---- */
  $$('[data-price-slider]').forEach(function (sl) {
    var scope  = sl.closest('.fgroup') || document;
    var lo     = sl.querySelector('[data-range-min]');
    var hi     = sl.querySelector('[data-range-max]');
    var fill   = sl.querySelector('[data-fill]');
    var fMin   = sl.querySelector('[data-field-min]');
    var fMax   = sl.querySelector('[data-field-max]');
    var outMin = scope.querySelector('[data-out-min]');
    var outMax = scope.querySelector('[data-out-max]');
    if (!lo || !hi) return;
    var MIN = +lo.min, MAX = +lo.max, GAP = +(lo.step || 1);
    var prefix = sl.getAttribute('data-prefix') || '';
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';
    function money(v) {
      return (prefix ? prefix + ' ' : '') + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function pct(v) { return MAX > MIN ? (v - MIN) / (MAX - MIN) * 100 : 0; }
    function paint() {
      var a = +lo.value, b = +hi.value;
      if (a > b - GAP) { // keep the handles from crossing
        if (document.activeElement === lo) { a = Math.max(MIN, b - GAP); lo.value = a; }
        else { b = Math.min(MAX, a + GAP); hi.value = b; }
      }
      var p1 = pct(a), p2 = pct(b);
      fill.style[rtl ? 'right' : 'left'] = p1 + '%';
      fill.style[rtl ? 'left' : 'right'] = 'auto';
      fill.style.width = (p2 - p1) + '%';
      if (outMin) outMin.textContent = money(a);
      if (outMax) outMax.textContent = money(b);
      if (fMin) fMin.value = a <= MIN ? '' : a; // blank at the bounds -> clean URL
      if (fMax) fMax.value = b >= MAX ? '' : b;
    }
    function submit() { var f = sl.closest('form'); if (f) f.submit(); }
    on(lo, 'input', paint); on(hi, 'input', paint);
    on(lo, 'change', submit); on(hi, 'change', submit);
    on(lo, 'pointerdown', function () { lo.style.zIndex = 5; hi.style.zIndex = 4; });
    on(hi, 'pointerdown', function () { hi.style.zIndex = 5; lo.style.zIndex = 4; });
    paint();
  });

  /* ---- PDP gallery (thumbnail -> main image swap, preloaded + crossfaded) ---- */
  var gMain = $('.gallery__main .ph');
  var gMainImg = $('.gallery__main img');
  var gSizes = gMainImg ? (gMainImg.getAttribute('sizes') || '') : '';

  // Warm the browser cache for every gallery image (at display size) when idle,
  // so thumbnail swaps are instant instead of triggering a fresh fetch on click.
  (function preloadGallery() {
    if (!gMainImg) return;
    var imgs = $$('.gthumb img');
    if (!imgs.length) return;
    var warm = function () {
      imgs.forEach(function (im) {
        var full = im.getAttribute('data-full'); if (!full) return;
        var pre = new Image();
        if (gSizes) pre.sizes = gSizes;
        var set = im.getAttribute('data-full-src'); if (set) pre.srcset = set;
        pre.src = full;
      });
    };
    if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 1800 }); else setTimeout(warm, 400);
  })();

  function galleryShow(th) {
    if (!th) return;
    $$('.gthumb').forEach(function (t) { t.classList.remove('is-on'); });
    th.classList.add('is-on');
    var ph = $('.ph', th);
    if (gMain && ph) {
      gMain.style.setProperty('--c1', ph.style.getPropertyValue('--c1'));
      gMain.style.setProperty('--c2', ph.style.getPropertyValue('--c2'));
    }
    var img = $('img', th);
    if (gMainImg && img) {
      var full = img.getAttribute('data-full') || img.src;
      var set = img.getAttribute('data-full-src') || '';
      var alt = img.alt || '';
      // fade out the current image, swap once the new one is ready, fade it in.
      // Replacing srcset is required or the browser keeps the old featured image.
      var apply = function () {
        gMainImg.style.opacity = '0';
        setTimeout(function () {
          gMainImg.srcset = set;
          gMainImg.src = full;
          gMainImg.alt = alt;
          requestAnimationFrame(function () { gMainImg.style.opacity = '1'; });
        }, 150);
      };
      var pre = new Image();
      if (gSizes) pre.sizes = gSizes;
      if (set) pre.srcset = set;
      pre.src = full;
      if (pre.complete && pre.naturalWidth) apply(); // already cached -> no wait
      else { pre.onload = apply; pre.onerror = apply; }
    }
    // keep the tapped thumb in view on the mobile horizontal strip
    if (th.scrollIntoView) { try { th.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) {} }
  }
  var thumbDragMoved = false;
  $$('.gthumb').forEach(function (th) {
    on(th, 'click', function () { if (thumbDragMoved) { thumbDragMoved = false; return; } galleryShow(th); });
  });

  /* ---- Desktop thumbnail rail: up/down arrows + drag-to-scroll ---- */
  (function () {
    var rail = $('.gallery__thumbs');
    if (!rail || !window.matchMedia || !matchMedia('(min-width:561px)').matches) return;
    var gal = rail.closest('.gallery');
    function refresh() {
      var scrollable = rail.scrollHeight > rail.clientHeight + 4;
      if (gal) gal.classList.toggle('has-thumb-nav', scrollable);
      var up = $('.thumb-nav--up'), dn = $('.thumb-nav--down');
      if (up) up.classList.toggle('is-off', rail.scrollTop <= 2);
      if (dn) dn.classList.toggle('is-off', rail.scrollTop >= rail.scrollHeight - rail.clientHeight - 2);
    }
    on(rail, 'scroll', refresh);
    refresh();
    setTimeout(refresh, 400); // recalc after thumbnails size/load
    on(window, 'resize', refresh);
    $$('.thumb-nav').forEach(function (btn) {
      on(btn, 'click', function () {
        var dir = parseFloat(btn.getAttribute('data-thumb-nav')) || 1;
        rail.scrollBy({ top: dir * Math.max(120, rail.clientHeight * 0.7), behavior: 'smooth' });
      });
    });
    var grabbing = false, startY = 0, startTop = 0;
    on(rail, 'pointerdown', function (e) {
      if (e.button != null && e.button !== 0) return;
      grabbing = true; thumbDragMoved = false; startY = e.clientY; startTop = rail.scrollTop;
      rail.classList.add('is-grabbing');
    });
    on(window, 'pointermove', function (e) {
      if (!grabbing) return;
      var dy = e.clientY - startY;
      if (Math.abs(dy) > 4) thumbDragMoved = true;
      rail.scrollTop = startTop - dy;
    });
    on(window, 'pointerup', function () {
      if (!grabbing) return;
      grabbing = false; rail.classList.remove('is-grabbing'); refresh();
    });
  })();

  /* ---- Mood banners: reveal colour on click (hover + touch handled in CSS) ---- */
  $$('.cat-card,.cat-tile,.editorial-full,.editorial').forEach(function (el) {
    on(el, 'click', function () { el.classList.add('is-color'); });
  });

  /* ---- accordions (PDP) & filter groups ---- */
  function collapsible(headSel, itemSel) {
    $$(headSel).forEach(function (head) {
      on(head, 'click', function () {
        var item = head.closest(itemSel);
        if (item) item.classList.toggle('is-open');
      });
    });
  }
  collapsible('.acc__head', '.acc');
  collapsible('.fgroup__head', '.fgroup');

  /* ---- mobile filters drawer toggle ---- */
  $$('.filter-toggle').forEach(function (btn) {
    on(btn, 'click', function () {
      var filters = $('.filters');
      if (filters) filters.classList.toggle('is-open');
    });
  });
  $$('.filters__close').forEach(function (btn) {
    on(btn, 'click', function () {
      var filters = $('.filters');
      if (filters) filters.classList.remove('is-open');
    });
  });

  /* ---- marquee pause toggle (in addition to :hover CSS) ---- */
  $$('.marquee').forEach(function (m) {
    on(m, 'click', function () { m.classList.toggle('is-paused'); });
  });

  /* ---- reveal on scroll ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ============================================================
     SHOPIFY AJAX CART
     ============================================================ */

  function reRenderCartDrawer() {
    return fetch(sectionsUrl('cart-drawer'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data) return;
        // Read the first key so a rename of the section id can't silently break this.
        var html = data['cart-drawer'];
        if (html == null) {
          var keys = Object.keys(data);
          html = keys.length ? data[keys[0]] : null;
        }
        if (html == null) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        // The section response wraps markup in the section's root; extract #cart-drawer.
        var fresh = tmp.querySelector('#cart-drawer') || tmp.firstElementChild;
        var current = $('#cart-drawer');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
          bindQty(current);
        }
      })
      .catch(function () { /* silent — drawer just won't refresh */ });
  }

  function refreshCartState() {
    return fetch((ROOT || '') + '/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart) setCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  /* ---- Add to cart: intercept product form submit ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches) return;
    var action = form.getAttribute('action') || '';
    // The theme posts add-to-cart forms to routes.cart_add_url (…/cart/add) and
    // quick-add forms carry [data-quick-add]. No <product-form> element is used.
    var isAddForm = /\/cart\/add(\.js)?$/.test(action) ||
                    form.hasAttribute('data-cart-add') ||
                    form.hasAttribute('data-quick-add') ||
                    form.classList.contains('product-form');
    if (!isAddForm) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');

    var formData = new FormData(form);
    fetch((ROOT || '') + '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast((res.body && res.body.description) || t9n('cart_error', 'Could not add to bag'));
          return;
        }
        var name = (res.body && (res.body.product_title || res.body.title)) || t9n('item', 'Item');
        return Promise.all([reRenderCartDrawer(), refreshCartState()]).then(function () {
          toast(name + ' ' + t9n('cart_added', 'added to bag'));
          var drawer = $('#cart-drawer');
          if (drawer && !form.hasAttribute('data-no-drawer')) openPanel(drawer);
        });
      })
      .catch(function () { toast(t9n('cart_error', 'Could not add to bag')); })
      .finally(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  });

  /* ---- Cart drawer line changes (qty + remove) via /cart/change.js ----
     Prefer the line item key (stable across re-renders) over the 1-based line
     index, which shifts when items are removed mid-session. */
  function changeLine(idOrLine, quantity) {
    var body = (typeof idOrLine === 'string')
      ? { id: idOrLine, quantity: quantity }
      : { line: idOrLine, quantity: quantity };
    return fetch((ROOT || '') + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart) setCartCount(cart.item_count);
        return reRenderCartDrawer();
      })
      .catch(function () {});
  }

  function lineRef(row) {
    var key = row.getAttribute('data-key');
    if (key) return key;
    return parseInt(row.getAttribute('data-line'), 10);
  }

  // qty change inside drawer (input carries data-line / row carries data-key)
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('#cart-drawer .qty input')) return;
    var row = input.closest('[data-line]');
    if (!row) return;
    var qty = Math.max(1, Math.min(99, parseInt(input.value, 10) || 1));
    input.value = qty;
    changeLine(lineRef(row), qty);
  });

  // remove line inside drawer
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('#cart-drawer [data-remove-line], #cart-drawer .cart-item__remove');
    if (!rm) return;
    e.preventDefault();
    var row = rm.closest('[data-line]');
    if (!row) return;
    changeLine(lineRef(row), 0);
  });

  /* ---- Full cart PAGE qty steppers: commit edits by submitting the cart form.
     The page inputs are name="updates[]" inside {% form 'cart' %}; on a stepper
     change we submit the form so the server cart updates (full page reload). ---- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.cart-layout .qty input[name="updates[]"]')) return;
    var form = input.closest('form');
    if (form) form.submit();
  });

  // Initialize count from server on load (avoids hardcoded mock value)
  refreshCartState();
})();
